export type ReviewStateRow = {
  id: string;
  status: "pending" | "flagged" | "approved";
  flagMessage: string | null;
  flagAckedAt: string | null;
  flagReply: string | null;
};

export type FlagState = { message: string | null; ackedAt: string | null; reply: string | null };

/** Pure reducer for the phone's 5s review-state poll. `localRemoteIds` are
 * this device's known `remoteId`s; `rows` is the server's response for
 * those ids. A missing id (deleted or approved-and-archived) and an
 * `approved` status both mean "wipe this script locally." A failed HTTP
 * call must never purge or clear an existing flag banner — losing exam
 * photos on a transient network blip is the one unacceptable failure
 * mode here. */
export function applyReviewState(
  localRemoteIds: string[],
  rows: ReviewStateRow[],
  httpOk: boolean,
): { purgeRemoteIds: string[]; flagByRemoteId: Record<string, FlagState | null> } {
  if (!httpOk) return { purgeRemoteIds: [], flagByRemoteId: {} };

  const byId = new Map(rows.map(row => [row.id, row]));
  const purgeRemoteIds: string[] = [];
  const flagByRemoteId: Record<string, FlagState | null> = {};

  for (const id of localRemoteIds) {
    const row = byId.get(id);
    if (!row || row.status === "approved") {
      purgeRemoteIds.push(id);
      continue;
    }
    flagByRemoteId[id] =
      row.status === "flagged"
        ? { message: row.flagMessage, ackedAt: row.flagAckedAt, reply: row.flagReply }
        : null;
  }

  return { purgeRemoteIds, flagByRemoteId };
}
